require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-jv-bwu.json") })
        }
      }, "path---photos-professional-jv-bwu");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-jv-bwu!./.cache/json/photos-professional-jv-bwu.json
// module id = 802
// module chunks = 231608221292675